import { useMemo } from 'react';
import * as FormulaActionMetadataKeys from 'automation-ui-action-features/actions/formula/FormulaActionMetadataKeys';
import parseWithErrors from 'automation-ui-formula-editor/formula-editor/grammar/parseWithErrors';
// @ts-expect-error untyped module
import hubLParser from 'automation-ui-formula-editor/formula-editor/grammar/hubL/hubLParser';
import { isSimpleHubLExpression } from 'automation-ui-formula-editor/formula-editor/grammar/expressionUtils';
import FormulaSummary from 'automation-ui-formula-editor/formula-editor/FormulaSummary';
import SimpleModeSummary from 'automation-ui-action-features/actions/formula/SimpleModeSummary';
import { jsx as _jsx } from "react/jsx-runtime";
export default function FormulaActionSummary({
  actionMetadata,
  flowObjectTypeId,
  getActionLabelById
}) {
  const formulaTemplate = actionMetadata.get(FormulaActionMetadataKeys.TEMPLATE);
  const {
    parsedExpression,
    syntaxErrors
  } = useMemo(() => parseWithErrors({
    parse: hubLParser.parse,
    input: formulaTemplate
  }), [formulaTemplate]);
  const isSimpleExpression = useMemo(() => !syntaxErrors.length && isSimpleHubLExpression(parsedExpression), [syntaxErrors.length, parsedExpression]);
  if (isSimpleExpression) {
    return /*#__PURE__*/_jsx(SimpleModeSummary, {
      parsedExpression: parsedExpression,
      getActionLabelById: getActionLabelById,
      objectTypeId: flowObjectTypeId,
      variableContexts: actionMetadata.get(FormulaActionMetadataKeys.VARIABLE_CONTEXT)
    });
  } else {
    return /*#__PURE__*/_jsx(FormulaSummary, {
      parsedExpression: parsedExpression
    });
  }
}